import {Functions} from "firebase/functions";

export default class FirebaseFunctions {
    static functions: Functions;
}
